'use client'
import { Button, styled } from '@mui/material'

export const ButtonRoundStyle = styled(Button)(({ theme }) => ({
  borderRadius: 50,
  textTransform: 'none',
  fontWeight: 600,
  gap: 2,
  height: 40,
  width: '100%',
}))
